import axios from "axios";
import { API_GET_BLOG_DATA, API_INSERT_BLOG_DATA, API_TOGGLE_BLOG_DATA, API_UPDATE_BLOG_DATA } from ".";

export const getBlogList = async (func, config) => {
    return axios.get(API_GET_BLOG_DATA, config).then(res => func(res.data.data));
}

export const insertBlogData = async (data, config) => {
    return axios.post(API_INSERT_BLOG_DATA, data, config).then((res) => res.data);
};

export const updateBlogData = async (data, config) => {
    return axios.put(API_UPDATE_BLOG_DATA, data, config).then((res) => res.data);
};

export const toggleBlogData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_BLOG_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};